import React from "react";
import { useTheme } from "@emotion/react";

import Tag from "./Tag";

export default function PaidTag() {
  const { colors } = useTheme();

  return (
    <Tag
      backgroundColor={colors.sysTextDefault}
      fontColor={colors.sysTextWhite}
      iconProps={{
        color: colors.sysTextWhite,
      }}
      icon="lock01"
      title="PAID"
      noShrink
    />
  );
}
